import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CaixaService } from './../../../service/caixa/caixa.service';
import { MatIconRegistry } from '@angular/material/icon';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CacheCodModel } from 'app/model/caixa/cache.model';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { CacheCodAlternativoService } from 'app/service/caixa/cache-cod-alternativo.service';


@Component({
  selector: 'app-dialog-cod-alternativo',
  templateUrl: './dialog-cod-alternativo.component.html',
  styleUrls: ['./dialog-cod-alternativo.component.scss']
})
export class DialogCodAlternativoComponent implements OnInit{

  codigos: CacheCodModel[];
  codigoControl = new FormControl('');
  formCod: FormGroup;
  cache = {} as CacheCodModel;
  msgVazio = '';
  cliente;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  loading = true;

  constructor(
    public dialogRef: MatDialogRef<DialogCodAlternativoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    iconRegistry: MatIconRegistry,
    private fb: FormBuilder,
    private cacheService: CacheCodAlternativoService,
    private _snackBar: MatSnackBar,
    sanitizer: DomSanitizer,
    private caixaService: CaixaService) {
      iconRegistry.addSvgIcon('question', sanitizer.bypassSecurityTrustResourceUrl('../../../../assets/images/question-circle.svg'));
      console.log(data);
      this.cliente = data.idCliente;
    }

    ngOnInit() {
      //this.getCodigos(this.data.idCliente);
      this.getCodigosByClienteAndUser();
      this.formCod = this.fb.group({
        id: [null],
        cliente: [this.cliente],
        usuario: [null],
        codAlternativo: [null],
        fixado: [true]
      })
    }

  onNoClick(): void {
    this.dialogRef.close();
  }

  editCache(cacheId) {
    this.cacheService.editCache(cacheId).subscribe(data => {
      console.log('ok');
    }, err => {
      console.error(err);
    })
  }

  setCodigo(code) {
    this.cache = code;
    this.codigoControl.setValue(code.codAlternativo);
    this.editCache(code.id);
  }

  inputFunction(e) {
    const element = document.getElementById('teste');
    console.log(element);
    const chr = String.fromCharCode(e.which);
        if ('1234567890QWERTYUIOPLKJHGFDSAZXCVBNM'.indexOf(chr) < 0) {
          return false;
        }
  }

  getCodigosByClienteAndUser() {
    if (this.cliente !== null && this.cliente !== undefined) {
      if (this.cliente.id !== null && this.cliente.id !== undefined) {
        this.caixaService.listarCacheCodAlternativo(this.cliente.id).subscribe(data => {
          console.log(data);
          this.loading = false;
          if (data.length === 0) {
            this.msgVazio = 'Nenhum código adicionado';
          } else {
            this.codigos = data;
          }
        }, err => {
          this.loading = false;
          console.error(err);
        });
      } 
    } else {
      this.loading = false;
      this.openSnackBarError('Nenhum código alternativo sendo utilizado !');
    }
  }

  addCodigo() {
    this.formCod.get('codAlternativo').setValue(this.codigoControl.value);
    this.caixaService.addCacheCodAlternativo(this.formCod.value).subscribe(data => {
      console.log(data);
    }, err => {
      if (err.error.message !== 'Este código alternativo já está cadastrado') {
        console.error(err);
      } else {
        this.openSnackBarError(err.error.message);
        console.error(err);
      }
    });
  }

  getCodigos(idCliente: number) {
    this.caixaService.getCodAlternativo(idCliente).subscribe(data => {
      if (data.length === 0) {
        this.msgVazio = 'Nenhum código adicionado';
      } else {
        this.codigos = data;
      }
    }, err => {
      console.error(err);
    })
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/dialog-cod-alternativo/dialog-cod-alternativo.component.ts